import React from 'react';
import StatusPage from '../common/StatusPage';
import { useAuthStore } from '../../stores/authStore';
import { isSuperAdmin } from '../../lib/roles';

interface RequireSuperAdminProps {
  children: React.ReactNode;
}

/** Keeps the UI guard aligned with the super-admin middleware on the API. */
export const RequireSuperAdmin: React.FC<RequireSuperAdminProps> = ({ children }) => {
  const user = useAuthStore((state) => state.user);

  if (!user || !isSuperAdmin(user.role)) {
    return <StatusPage code={403} />;
  }

  return <>{children}</>;
};

export default RequireSuperAdmin;
